import React from 'react';
import { requestHelpers } from '../../../helpers';
import Anchor from "../../dashboardNew/objects/Anchor";
import { browserHistory } from 'react-router';
import { getField } from './../../../helpers/common/form';

export default class PasswordChange extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            sent    : false,
            error   : false,
            validation : {},
            fields  : [
                {
                    tagName         : "input",
                    name            : "password",
                    type            : "password",
                    label           : "Password",
                    placeholder     : "***********", 
                    required        : true,
                    classOveride    : "col-12 form-group alt"
                },
                {
                    tagName         : "input",
                    name            : "password_confirmation",
                    type            : "password",
                    label           : "Password Confirmation",
                    placeholder     : "***********", 
                    required        : true,
                    classOveride    : "col-12 form-group alt"
                }
            ]
        };

        this.formRef = React.createRef();
    }

    componentWillMount(){
        const params = {};
        window.location.search.substring(1).split('&').forEach( param => {
            let split = param.split('=');
            params[split[0]] = split[1];
        });


        if( !params.hash || !params.person_id ){
            console.warn && console.warn('you dont have the required parameters to view this page');
            return browserHistory.push( '/login' );
        };

        this.setState({ params });
    }

    buildFields = () => this.state.fields.map( field => getField( field ) )

    submit(){

        const password = this.formRef.current.querySelector( '#password' ).value;
        const passwordConfirm = this.formRef.current.querySelector( '#password_confirmation' ).value;

        if( !/((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,50})/.test( password ) ){
            return this.setState({
                validation : {
                    valid : false,
                    message : "your password needs to be eight characters or more in length and contain a capital, lowercase, number and a symbol"
                }
            });
        };

        if( password !== passwordConfirm ){
            return this.setState({
                validation : {
                    valid : false,
                    message : "your passwords didnt match"
                }
            });
        };

        const send = () => {
            
            const body = {
                password,
                password_confirmation : passwordConfirm,
                isUK                  : window.localStorage.getItem('site_of_origin') === 'gb',
                hash                  : this.state.params.hash,
                person_id             : this.state.params.person_id,
                dontCheckMembership   : false
            };

            requestHelpers
                .unauthenticatedPostRequest( '/authentication/password/change', body )
                .then(() => this.setState({ sent : true }) )
                .catch( error => this.setState({ error : true }));

        };

        this.setState({
            validation : {
                valid : true,
                message : ""
            }
        }, () => send() );

    }

    contactSuccessMessage(){
        return (
            <div className="col-12 contact-success">
                <h3 className="heading-two">Your password has been successfully changed.</h3>
                <Anchor path='/login' anchorClass='theme-button' internal>
                    login
                </Anchor>
            </div>
        );
    }

    contactErrorMessage(){
        return (
            <div className="col-12 contact-success">
                <h3 className="heading-two">Oops, there was an error changing your password.</h3>
                <Anchor path='/' anchorClass='theme-button' internal>
                    Go Home
                </Anchor>
            </div>
        );
    }

    content(){
        if( !this.state.sent && !this.state.error ){
            return (
                <form key='form' className="contact-form" ref={ this.formRef }>
                    { this.buildFields() }
                    <div className="col-12 form-group button">
                        <button className="theme-button" type="button" value="button" onClick={() => this.submit()}>Send</button>
                    </div>
                </form>
            );
        };
        if( this.state.error ){ return this.contactErrorMessage() };
        return this.contactSuccessMessage();
    }

    render() {
        return (
            <div className="portal-page-wrapper contact-page theme-page-whole-blue">
                <div className="image" style={{ backgroundImage: 'url(/images/contact.jpg)' }}></div>
                <div className="container inner-content">
                    <div className="row">
                        <div key='heading' className="col-12 heading">
                            <h1 className="heading-main">Change Password</h1>
                            <p className="body-copy">please fill in the form below to change your password.</p>
                            { this.state.validation.valid === false && <p className="validation-error">{ this.state.validation.message }</p> }
                        </div>
                        { this.content() }
                    </div>
                </div>
            </div>
        );
    };
};




// WEBPACK FOOTER //
// src/client/components/common/authentication/PasswordChange.js